export default function SiteHeader({ children }) {
  return (
    <header className="ps-header">
      <a href="/" className="ps-header__brand" aria-label="Início">
        <img src="/snb-logo.png" alt="Grupo SNB" className="ps-logo ps-logo--small" />
      </a>
      {children}
    </header>
  );
}
